import React from 'react';
export const CanvasGreyed = () => (
  <svg width="105px" height="97px" viewBox="0 0 105 97" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1344.000000, -2096.000000)">
        <g transform="translate(1344.000000, 2097.000000)">
          <path
            d="M79.5122,92.8979 C79.5122,94.3009 61.8392,95.4389 40.0372,95.4389 C18.2362,95.4389 0.5622,94.3009 0.5622,92.8979 C0.5622,91.4949 18.2362,90.3569 40.0372,90.3569 C61.8392,90.3569 79.5122,91.4949 79.5122,92.8979"
            fill="#F3F4F6"
          />
          <polygon
            fill="#C3D3D8"
            points="17.527 92.429 21.252 92.429 36.252 22.256 32.527 22.256"
          />
          <polygon
            fill="#C3D3D8"
            points="59.568 92.429 62.637 92.429 47.637 22.256 44.568 22.256"
          />
          <polygon
            stroke="#C3D3D8"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="16 54.2836 63.31 54.2836 63.31 0 16 0"
          />
          <polygon
            stroke="#C3D3D8"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="10 57.498 70 57.498 70 54 10 54"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="24 69.71 56 69.71 56 66.212 24 66.212"
          />
          <g transform="translate(83.000000, 56.710000)">
            <path d="M0.5991,0.5736 L11.1181,0.5736" fill="#FFFFFF" />
            <path
              d="M0.5991,0.5736 L11.1181,0.5736"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(83.000000, 61.710000)">
            <path d="M0.5991,0.6791 L16.7441,0.6791" fill="#FFFFFF" />
            <path
              d="M0.5991,0.6791 L16.7441,0.6791"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(90.000000, 67.710000)">
            <path d="M0.188,0.5531 L14.607,0.5531" fill="#FFFFFF" />
            <path
              d="M0.188,0.5531 L14.607,0.5531"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M89.5112,57.2836 L89.5112,62.3886"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.7983,62.3891 L96.7983,68.2631"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
